<template>
    <div :class="[!this.$root.settings.showFilter ? 'noFilter' : '', 'pricelistContainer']">
        <actionCodeInput class="hideInDesktop" v-if="displayActionCodeInput && !$store.state.pointshop"></actionCodeInput>
        <div class="priceListToolBar">
            <searchBar v-if="this.$root.settings.showFilter" @setHeight="setHeight" />
            <div v-if="!$store.state.mobile" class="viewToggle">
                <button :class="['listButton', 'sortBtn', view == 'list' ? 'active' : '']" @click="view = 'list'"><i class="fas fa-bars"></i></button>
                <button :class="['gridButton', 'sortBtn', view == 'grid' ? 'active' : '']" @click="view = 'grid'"><i class="fas fa-th"></i></button>
            </div>
        </div>
        <div class="pricelist">
            <div class="activeFilter" v-show="filterPillList.length > 0">
                <transition-group name="bounce" :duration="{ enter: 300, leave: 0 }">
                    <div class="filterPillContainer" v-for="(filter, index) in filterPillList" :key="filter.name+index">
                        <div @click="removeFromFilter(index)" class="filterPill">
                            <p>{{filter.name}}</p>
                            <i class="fas fa-times"></i>
                        </div>
                    </div>
                </transition-group>
                <div class="filterPillContainer">
                    <div @click="removeFromFilter('x')" class="filterPill clearPill">
                        <p>{{this.$root.language.wsm_Reset}}</p>
                        <i class="fas fa-times"></i>
                    </div>
                </div>
            </div>
            <contentloaders :view="view"></contentloaders>
            <h3 v-if="(((typeof $store.state.priceList[0] != 'undefined' && $store.state.priceList[0].globalProducts.length == 0)) && (typeof $store.state.filter != 'undefined' && $store.state.filter.length > 0) && !$store.state.loading)" class="noResult">{{this.$root.language.wsm_noResult}}</h3>
            <div :class="[typeof $store.state.filter != 'undefined' && $store.state.filter.length == 0 && view == 'list' ? view : '', view == 'grid' ? 'inlineClass' : '', $store.state.loading ? 'loading' : '']" v-for="(attr, index) in priceList" :key="index">
                <div class="productCat" v-if="(typeof attr.name != 'undefined')">{{attr.name}}</div>
                <div :class="[typeof $store.state.filter != 'undefined' && $store.state.filter.length > 0 || view == 'grid' ? view : '']" v-for="(product, index2) in attr.globalProducts" :key="index2">
                    <product :product="product" :quantity="0" :view="view"  :backorder="backorder"></product>
                    <hr v-if="((index2+1) != attr.globalProducts.length) && view == 'list'">
                </div>
            </div>
        </div>
        
        <div v-if="($store.state.searchResult.show && $store.state.filter.length > 0) || (typeof $store.state.searchResult.result[0] != 'undefined' && $store.state.searchResult.result[0].globalProducts.length == 0 && $store.state.searchResult.show)" class="pricelist">
            <h3 v-if="$store.state.searchResult.show && $store.state.searchResult.result[0].globalProducts.length == 0 && !$store.state.loading" class="noResult">{{this.$root.language.wsm_noResult}}</h3>
            <div :class="[typeof $store.state.filter != 'undefined' && $store.state.filter.length > 0 || view == 'grid' ? view : 'list', $store.state.loading ? 'loading' : '']" v-for="(attr, index2) in priceList" :key="index2">
                <div class="productCat" v-if="(typeof attr.name != 'undefined')">{{attr.name}}</div>
                <div :class="[typeof $store.state.filter != 'undefined' && $store.state.filter.length > 0 || view == 'grid' ? view : 'list']" v-for="(product, index3) in attr.globalProducts" :key="index3">
                    <product :product="product" :quantity="0" :view="view" :backorder="backorder" ></product>
                    <hr v-if="((index3+1) != attr.globalProducts.length) && view == 'list'">
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import settingsComponent from './settings'

import searchBar from './searchBar'
import product from './product.vue'
import contentloaders from './contentloaders'
import actionCodeInput from './actionCodeInput.vue'


export default {
    name: "pricelist",
    components: {
        searchBar,
        contentloaders,
        product,
        settingsComponent,
        actionCodeInput,
    },
    
    data() {
        return {
            view: this.$root.settings.defaultView,
            showPill: false,
            filterPillList: [],
            grid: 3,
            backorder: this.$root.backorder,
            showActionCodeInput: ['en_IE', 'de_DE']
        };
    },
    created() {
        this.$store.state.pointshop = this.$root.pointshop
        //Let the filter handle getting the pricelist if there's a parameter called filter
        var filter;
        var parser = document.createElement('a'); //Create a container       
        parser.href = window.location.href; //Get the whole URL       
        var parameter = parser.search; //search for parameter
        var value = parser.search;
        parameter = parameter.substr(parameter.indexOf("?") + 1);
        parameter = parameter.substr(0, parameter.indexOf('='));

        var showAndHideAttrCollection = [this.$root.settings.showCat, this.$root.settings.hideCat]; //create a colection of selected and blacklisted attributes;      

        if (parameter != 'filter') {
            this.$store.dispatch("getPriceList", showAndHideAttrCollection);// dispatch selected Attributes array, and the balcklisted AttributeValues to the store
        }
        this.filterPillList = this.$store.state.priceListFilterPills;
        window.addEventListener('resize', this.setHeight)
    },
    destroyed() {
        window.removeEventListener("resize", this.setHeight);
    },
    mounted() {
        this.$store.subscribe((mutation, state) => {
            switch (mutation.type) {
                case 'setFilter':
                    this.filterPillList = this.$store.state.priceListFilterPills;
                    break;
                case 'applySearchResult':
                    this.filterPillList = [];
                    state.priceListFilterPills = [];
                    setTimeout(() => {
                        this.setHeight();
                    }, 50)
                    break;
                case 'loadingHandler':
                    if (mutation.payload == false) {
                        this.$nextTick().then(() => {
                            this.setHeight();
                        })
                    }
                    break;
            }
        })
    },
    watch: {
        view: function() {
            this.$nextTick().then(() => {
                setTimeout(() => {
                    this.setHeight();
                    this.$store.dispatch('screenSize', (window.innerWidth <= 700))
                }, 200)
            })
        },
    },
    methods: {
        setHeight: function() {
            if (this.view == 'grid') {
                var heightArray = [];
                var gridWidth;
                var iteration = 0;
                var rest = 0;
                Array.from(document.getElementsByClassName('inlineClass')).forEach((inline, inlineIndex) => {
                    rest = 0;
                    if (inline.getElementsByClassName('productContainer').length > 3) {
                        gridWidth = 3
                    } else {
                        gridWidth = inline.getElementsByClassName('productContainer').length
                    }
                    if ((window.innerWidth >= 900) && !this.$root.settings.showFilter) {
                        gridWidth = 4;
                    } else if ((window.innerWidth <= 900) && this.$root.settings.showFilter) {
                        gridWidth = 2;
                    } else if ((window.innerWidth <= 700) && !this.$root.settings.showFilter) {
                        gridWidth = 2
                    }
                    rest = inline.getElementsByClassName('productContainer').length % 3
                    Array.from(inline.getElementsByClassName('productContainer')).forEach((el, index) => {
                        el.children[1].removeAttribute('style')
                        iteration++
                        if (iteration <= gridWidth) {
                            heightArray.push(el.offsetHeight)
                            if (((index + 1) % gridWidth) == 0) {
                                for (var i = 0; i < gridWidth; i++) {
                                    var heightLeft = (Math.max(...heightArray) - inline.getElementsByClassName('productContainer')[index - i].offsetHeight);
                                    var final = inline.getElementsByClassName('productContainer')[index - i].children[1].offsetHeight + heightLeft;
                                    inline.getElementsByClassName('productContainer')[index - i].children[1].style.minHeight = final + 'px';
                                }
                                iteration = 0;
                                heightArray = [];
                            } else if (rest >= 2 && rest == (inline.getElementsByClassName('productContainer').length - (index - 1)) && gridWidth > 2) {
                                for (var k = 0; k < heightArray.length; k++) {
                                    var heightLeft = (Math.max(...heightArray) - inline.getElementsByClassName('productContainer')[index - k].offsetHeight);
                                    var final = inline.getElementsByClassName('productContainer')[index - k].children[1].offsetHeight + heightLeft;
                                    inline.getElementsByClassName('productContainer')[index - k].children[1].style.minHeight = final + 'px';
                                    rest--;
                                }
                            }
                        }
                    })
                    iteration = 0;
                    heightArray = [];
                    gridWidth = 0;
                })
            } else {
                const array = Array.from(document.getElementsByClassName('productContainer'));
                array.forEach(el => {
                    el.children[0].removeAttribute('style')
                });
            }
        },
        //gets called when the user click on the "Remove selected filters" button
        removeFromFilter: function(index) {
            var checkedArray = [];
            if (index == 'x') {
                this.filterPillList = [];
                this.$store.state.priceListFilterPills = [];
            } else {
                this.filterPillList.splice(index, 1);
                this.$store.state.priceListFilterPills.forEach(el => {
                    checkedArray.push(el.attributeValueId)
                })
            }
            this.$store.dispatch("getPriceList", [checkedArray, this.$root.settings.hideCat]);
        }
    },
    computed: {
        locale: function() {
            return window.locale
        },
        itemsComputed: function(){
            let arrayList = [];
            
            for(let n = 0; n< 10; n++){
                let tempObj = {};
                tempObj['uid'] = 'unique_'+n;
                tempObj['text'] = 'text-Text'+n;
                arrayList.push(tempObj);
            }
            return arrayList;
        },
        priceList: function() {
            if (this.$store.state.searchResult.show) {
                this.$nextTick()
                    .then(() => {
                        this.setHeight();
                    })
                return this.$store.state.searchResult.result
            } else {
                return this.$store.getters.priceList;
            }
        },
        displayActionCodeInput: function(){
            return this.showActionCodeInput.includes(this.locale)
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#integrationTest .pricelist {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    text-align: left;
}

.pricelistContainer {
    display: inline-block;
    vertical-align: top;
    margin: 0 auto;
    text-align: center;
    width: 71%;
    float: right;
}

.loading {
    transition: all 0.3s ease-in-out;
    opacity: 0.3;
}

.activeFilter {
    min-height: 50px;
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-left: 17px;
    .filterPillContainer {
        width: auto;
        display: inline-block;
    }
    .filterPill {
        width: auto;
        display: inline-block;
        background: #004570;
        padding: 5px;
        border-radius: 20px;
        color: white;
        position: relative;
        box-shadow: 3px 2px 7px 0px #cbcbcb;
        padding-left: 12px;
        padding-right: 7px;
        cursor: pointer;
        min-width: 41px;
        margin-right: 8px;
        margin-top: 10px;
        &:hover {
            background: #0c659d;
        }
        p {
            color: white;
            display: block;
            vertical-align: middle;
            font-size: 0.8em;
            width: auto;
            margin: 0;
            margin-right: 18px;
            margin-top: 0px;
        }
        i {
            color: white;
            vertical-align: middle;
            font-size: 0.7em;
            text-align: center;
            position: absolute;
            right: 10px;
            top: 8px;
        }
    }
    .clearPill {
        background: #7caf63;
        &:hover {
            background: #94ce77;
        }
    }
}

.noFilter.pricelistContainer {
    width: 100%;
    .grid {
        width: 23%;
    }
}

.noResult {
    text-align: center;
    font-size: 3em;
    color: #a8a8a8;
    display: block;
    text-align: center;
    margin-top: 33px;
}

.inlineClass {
    //display: inline;
}

.priceListToolBar {
    height: 43px;
}

.viewToggle {
        text-align: right;
        width: auto;
        margin: 5px;
        
    
    .listButton {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-left: none;
        border-right: none;
    }
    .gridButton {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-right: none;
        border-left: none;
    }
    .sortBtn {
        padding: 5px;
        background: white;
        width: 43px;
        border: 1px solid gray;
        height: 43px;
        transition: all 0.2s ease-in-out;
        cursor: pointer;
        &:hover:not(.active) {
            background: #00457029;
            i {
                color: #004570;
            }
        }
        i {
            color: #004570;
        }
    }
    .gridButton:not(.active) {
        border-left: none;
    }
    .listButton:not(.active) {
        border-right: none;
    }
    .active {
        background: #7caf63 !important;
        border: 1px solid #7caf63;
        i {
            color: white;
        }
    }
}

.productCat {
    background: #004570;
    padding: 7px;
    color: white;
    text-align: left;
    width: 97%;
    margin-bottom: 20px;
    transition: all 0.3s ease-in-out;
    clear: both;
}

.grid {
    width: 31.3%;
    display: inline-block;
    margin: 1%;
    vertical-align: top;
    transition: all 0.2s ease-in-out;
    &>div {
        margin-top: 28px;
    }
}

.list {
    width: 100%;
    display: block;
    text-align: center;
    margin: 0 auto;
    transition: all 0.2s ease-in-out;
    hr {
        width: 96%;
        border: 1px solid #eaeaea;
    }
}
.list, .inlineClass{
    margin-top: 22px;
}

.attrHeader {
    background: #cbe9fc;
    color: #004570;
    text-align: left;
    padding: 10px;
    padding-left: 17px;
    border-radius: 4px;
    font-size: 1.3em;
    font-weight: bold;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */

    {
    opacity: 0;
}

.bounce-enter-active {
    animation: bounce-in .3s;
}

.bounce-leave-active {
    animation: bounce-in 0s reverse;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}

.productShopMoble {
    .searchBar {
        margin-left: 0;
    }
    .pricelistContainer {
        width: 100%;
    }
    .grid {
        width: 100%;
    }
}


@media screen and (max-width: 900px) {
   
    .grid {
        width: 48%;
    }
    .noFilter.pricelistContainer {
        .grid {
            width: 31%;
        }
    }
}

@media screen and (max-width: 700px) {
    .noFilter.pricelistContainer {
        .grid {
            width: 48%;
        }
    }
}


@media screen and (max-width: 650px) {
    .noFilter.pricelistContainer {
        .grid {
            width: 100%;
        }
    }
}

 .turquoiseTheme{
    .productCat{
        background: #418a90;
    }
 }
</style>
